import { useEffect, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";

// third-party
import ReactApexChart from "react-apexcharts";
import React from "react";

class DonutChart extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { options, type = "donut", series, width = 600 } = this.props;
    return (
      <ReactApexChart
        options={options}
        series={series}
        type={type}
        width={width}
      />
    );
  }
}

export default DonutChart;




